import type { ServiceActivityCategory } from "@shared/serviceActivityCategory";

/** One colour family per activity category, shared by the RO timeline and the dashboard. */
export const ACTIVITY_DOT_CLASS: Record<ServiceActivityCategory, string> = {
  work_timer: "bg-amber-500",
  assignment: "bg-sky-500",
  status: "bg-violet-500",
  customer_report: "bg-teal-600",
  customer_approval: "bg-emerald-600",
  finance: "bg-indigo-500",
  parts: "bg-orange-500",
  general: "bg-slate-300",
};

export const ACTIVITY_BADGE_CLASS: Record<ServiceActivityCategory, string> = {
  work_timer: "bg-amber-50 text-amber-800",
  assignment: "bg-sky-50 text-sky-800",
  status: "bg-violet-50 text-violet-800",
  customer_report: "bg-teal-50 text-teal-800",
  customer_approval: "bg-emerald-50 text-emerald-800",
  finance: "bg-indigo-50 text-indigo-800",
  parts: "bg-orange-50 text-orange-800",
  general: "bg-slate-100 text-slate-600",
};
